import axios from "axios";
import { apiURL } from "../config/default";

export const getAllRoutes = async () => {
  try {
    const res = await axios.get(`${apiURL}admin/get-all-routes`);
    return res;
  } catch (err) {
    console.log(err);
  }
};
export const getAllTypes = async () => {
  try {
    const res = await axios.get(`${apiURL}admin/get-all-roles`);
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const sendPermissions = async (data) => {
  // console.log(data)
  try {
    const res = await axios.post(
      `${apiURL}admin/add-permissions-to-role`,
      data
    );
    return res;
  } catch (err) {
    console.log(err);
  }
};

/**
 * Creates a new role with a type and initial permissions.
 * @param {object} roleData The payload with 'type' and 'permissions'.
 * @returns {Promise<object>} The new role data.
 */
export const createNewRole = async (roleData) => {
  try {
    const res = await axios.post(`${apiURL}admin/create-new-role`, roleData);
    return res.data;
  } catch (err) {
    console.error("Error creating a new role:", err);
    throw err;
  }
};

/**
 * Fetches all roles with their associated permissions.
 * @returns {Promise<object>} An object containing an array of roles and the total count.
 */
export const getAllRolesWithPermissions = async () => {
  try {
    const res = await axios.get(
      `${apiURL}admin/get-all-permissions`
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching all roles with permissions:", err);
    throw err;
  }
};

/**
 * Fetches all roles (types only).
 * @returns {Promise<object>} An object containing an array of roles and the total count.
 */
export const getAllRoleTypes = async () => {
  try {
    const res = await axios.get(`${apiURL}admin/get-all-roles`);
    return res.data;
  } catch (err) {
    console.error("Error fetching all role types:", err);
    throw err;
  }
};

/**
 * Fetches permissions for a single role by type or ID.
 * @param {string} identifier A role type or ID.
 * @param {string} identifierType 'type' or 'id'.
 * @returns {Promise<object>} The single role's data.
 */
export const getSingleRolePermissions = async (
  identifier,
  identifierType = "id"
) => {
  try {
    const res = await axios.get(
      `${apiURL}admin/get-single-role-permissions?${identifierType}=${identifier}`
    );
    return res?.data;
  } catch (err) {
    console.error("Error fetching single role permissions:", err);
    throw err;
  }
};

/**
 * Adds new permissions to an existing role.
 * @param {object} data The payload with 'id' and 'permissions' to add.
 * @returns {Promise<object>} The API response confirming the addition.
 */
export const addPermissionsToRole = async (data) => {
  try {
    const res = await axios.post(
      `${apiURL}admin/add-permissions-to-role`,
      data
    );
    return res.data;
  } catch (err) {
    console.error("Error adding permissions to role:", err);
    throw err;
  }
};

/**
 * Updates an existing role's type or replaces its permissions.
 * @param {string} roleId The ID of the role to update.
 * @param {object} updateData The data to update (e.g., { type: 'newType' }).
 * @returns {Promise<object>} The updated role data.
 */
export const updateRole = async (roleId, updateData) => {
  try {
    const res = await axios.put(
      `${apiURL}admin/update-role/${roleId}`,
      updateData
    );
    return res.data;
  } catch (err) {
    console.error("Error updating role:", err);
    throw err;
  }
};

/**
 * Deletes a role by its ID.
 * @param {string} roleId The ID of the role to delete.
 * @returns {Promise<object>} The API response confirming the deletion.
 */
export const deleteRole = async (roleId) => {
  try {
    const res = await axios.delete(`${apiURL}admin/delete-role/${roleId}`);
    return res.data;
  } catch (err) {
    console.error("Error deleting role:", err);
    throw err;
  }
};

/**
 * Removes a specific permission from a role.
 * @param {string} roleId The ID of the role.
 * @param {object} permissionData The payload with the 'permissionTitle'.
 * @returns {Promise<object>} The API response confirming the removal.
 */
export const removePermissionFromRole = async (roleId, permissionData) => {
  try {
    const res = await axios.delete(
      `${apiURL}admin/remove-permission/${roleId}`,
      { data: permissionData }
    );
    return res.data;
  } catch (err) {
    console.error("Error removing permission from role:", err);
    throw err;
  }
};



